import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { mdiRefresh } from "@mdi/js";
import Icon from "@mdi/react";

import Header from "components/Header";
import LaneTrendItem from "features/main/Loads/modules/LaneTrendItem";
import MainLayout from "layouts/Main";
import { IRateTrendResponse } from "models/RateTrend";
import { getLaneTrendAPI } from "services/api/rateTrend";
import { handleLoading } from "store/global/loader";
import styles from "./style.module.scss";

export default function LaneRateTrend() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [offset, setOffset] = useState(0);
  const [nextLink, setNextLink] = useState<string | null>(null);
  const [laneTrendData, setLaneTrendData] = useState<IRateTrendResponse[]>();

  const fetchLaneRateTrend = async () => {
    if (!state) navigate(-1);
    dispatch(handleLoading(true));
    try {
      const {
        data: { results, next }
      } = await getLaneTrendAPI({ offset: offset, ...state });
      setNextLink(next);
      if (laneTrendData) setLaneTrendData([...laneTrendData, ...results]);
      else setLaneTrendData(results);
    } finally {
      dispatch(handleLoading(false));
      setOffset((prev) => prev + 20);
    }
  };

  useEffect(() => {
    fetchLaneRateTrend();
  }, []);

  return (
    <MainLayout
      desktopTitle="Post Load"
      className={styles.loadPostRateTrendContainer}
      customHeader={<Header label="Lane Rate Trend" />}>
      {laneTrendData ? (
        <>
          <ul className={styles.loadPostRateTrendLaneList}>
            {laneTrendData.length ? (
              laneTrendData.map((item) => <LaneTrendItem key={item.id} data={item} />)
            ) : (
              <span className="mt-5 text-lg text-center">No data</span>
            )}
          </ul>

          {nextLink !== null ? (
            <button type="submit" className={styles.loadMore} onClick={fetchLaneRateTrend}>
              <Icon path={mdiRefresh} />
              <span className="text-lg">Load More</span>
            </button>
          ) : null}
        </>
      ) : null}
    </MainLayout>
  );
}
